import React from "react";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import {
  CANADA_MARKETPLACES,
  MARKETPLACE_SUMMARY_PAGES,
  PROVINCE_MARKETPLACE_SUMMARY, USA_MARKETPLACES,
} from './constants';
import {
  Box,
  Chip, FormControlLabel,
  TableCell,
} from '@mui/material';
import "../shippingSummary/ShippingSummary.css";
import { Clear, HourglassEmptyTwoTone } from '@material-ui/icons';
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { IconButton, TableBody, TableHead, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CircleIcon from '@mui/icons-material/Circle';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Refresh';
import Utils from '../../Utils/Utils';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

class ProvinceSummaryTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedYear: new Date().getFullYear(),
      selectedQuarters: null,
      selectedCountry: 'Canada',
      selectedMonth: '',
      selectedMarketplace: [],
      openMarketplace: false,
      provinceSearch: '',
      selectedValueType: 'sales',
      combineTax: false,
      splitTaxColumns: false,
      isRefresh: false,
    };

  }

  componentDidMount() {
    this.props.getTableSetting(this.props.user.userId)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.tableMarketplaceSetting !== this.props.tableMarketplaceSetting) {

      const savedSetting =
        this.props.tableMarketplaceSetting?.marketplaceProvinceSummaryFilterSetting || {};

      const current = this.state.marketplaceProvinceSummaryFilterSetting || {};

      const {
        country = current.country || 'Canada',
        year = current.year || new Date().getFullYear(),
        month = current.month || '',
        quarters = current.quarters || '',
        marketplaces = current.marketplaces || [],
      } = savedSetting;

      const mergedSetting = {
        country,
        year,
        month,
        quarters,
        marketplaces,
      };

      this.setState(
        {
          marketplaceProvinceSummaryFilterSetting: mergedSetting,
          selectedCountry: country,
          selectedYear: year,
          selectedMonth: month,
          selectedQuarters: quarters,
          selectedMarketplace: marketplaces,
        },
        () => {
          this.listProvinceSummary();
        }
      );
    }
  }

  handleSearchChange = (value) => {
    this.setState({ provinceSearch: value });
  };

  handleProvinceSearchChange = (event) => {
    this.setState({ provinceSearch: event.target.value });
  };

  handleMarketplaceChange = (event, value) => {
    this.setState({ selectedMarketplace: value }, () => {
     this.onFiltersInputChange('marketplaces', { target: { value } });
    });
  };

  getTableHeaders = () => {
    const { marketplaceProvinceSummary } = this.props;
    const { provinceSearch, splitTaxColumns, combineTax } = this.state;

    if (!marketplaceProvinceSummary || Object.keys(marketplaceProvinceSummary).length === 0)
      return [[<TableCell align="center"  sx={{ fontWeight: 'bold' }}>Month</TableCell>]];

    const sampleMarketplace = Object.keys(marketplaceProvinceSummary)[0];
    const marketplaceData = marketplaceProvinceSummary[sampleMarketplace];

    if (!marketplaceData || Object.keys(marketplaceData).length === 0)
      return [[<TableCell align="center"  sx={{ fontWeight: 'bold' }}>Month</TableCell>]];

    const firstMonthKey = Object.keys(marketplaceData).find(
      (key) => marketplaceData[key] && Object.keys(marketplaceData[key]).length > 0
    );

    if (!firstMonthKey)
      return [[<TableCell align="center"  sx={{ fontWeight: 'bold' }}>Month</TableCell>]];

    let provinces = Object.keys(marketplaceData[firstMonthKey] || {});

    if (provinceSearch) {
      const search = provinceSearch.toLowerCase();
      provinces = provinces.filter((p) => p.toLowerCase().includes(search));
    }

    if (splitTaxColumns) {
      const mainHeaders = [
        <TableCell
           key="month"
          rowSpan={2}
          align="center"
          sx={{ fontWeight: 'bold', borderRight: '1px solid #ddd' }}
        >
          Month
        </TableCell>,
      ];

      provinces.forEach((p) => {
        mainHeaders.push(
          <TableCell
            key={p}
            align="center"
            colSpan={2}
             sx={{
              fontWeight: 'bold',
              borderRight: '1px solid #ddd',
            }}
          >
            {p}
          </TableCell>
        );
      });

      mainHeaders.push(
        <TableCell
          key="total"
          rowSpan={2}
          align="right"
          sx={{ fontWeight: 'bold'}}
        >
          Total
        </TableCell>
      );

      const subHeaders = [];

      provinces.forEach((p) => {
        subHeaders.push(
          <TableCell
            key={`${p}-received`}
            align="right"
            sx={{
              fontWeight: 500,
              borderRight: '1px solid #ddd',
            }}
          >
            Received
          </TableCell>
        );
        subHeaders.push(
          <TableCell
            key={`${p}-withheld`}
            align="right"
            sx={{
              fontWeight: 500,
              borderRight: '1px solid #ddd',

            }}
          >
            Withheld
          </TableCell>
        );
      });

      return [mainHeaders, subHeaders];
    }

    if (combineTax) {
      const headers = [
        <TableCell key="month" align="center"  sx={{ fontWeight: 'bold' }}>Month</TableCell>
      ];

      provinces.forEach((p) => {
        headers.push(
          <TableCell key={p} align="right"  sx={{ fontWeight: 'bold' }}>
            {p}
          </TableCell>
        );
      });

      headers.push(
        <TableCell key="total" align="right"  sx={{ fontWeight: 'bold' }}>Total</TableCell>
      );

      return [headers];
    }

    const headers = [
      <TableCell key="month" align="center"  sx={{ fontWeight: 'bold' }}>Month </TableCell>
    ];

    provinces.forEach((p) => {
      headers.push(
        <TableCell key={p} align="right"  sx={{ fontWeight: 'bold' }}>
          {p}
        </TableCell>
      );
    });

    headers.push(
      <TableCell key="total" align="right"  sx={{ fontWeight: 'bold' }}>Total</TableCell>
    );

    return [headers];
  };

  getTableData = () => {
    const { marketplaceProvinceSummary } = this.props;
    const { selectedCountry, selectedQuarters, selectedMonth, provinceSearch, selectedValueType, combineTax, splitTaxColumns } = this.state;

    if (!marketplaceProvinceSummary || Object.keys(marketplaceProvinceSummary).length === 0)
      return [];

    const marketplaceKeys = Object.keys(marketplaceProvinceSummary).filter((m) => {
      if (selectedCountry === 'Canada') return m.includes('_ca');
      if (selectedCountry === 'United States') return m.includes('_com') || m.includes('_us');
      return false;
    });

    if (marketplaceKeys.length === 0) return [];

    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    let startMonth = 1;
    let endMonth = 12;

    if (!selectedMonth) {
      switch (selectedQuarters) {
        case 1: startMonth = 1; endMonth = 3; break;
        case 2: startMonth = 4; endMonth = 6; break;
        case 3: startMonth = 7; endMonth = 9; break;
        case 4: startMonth = 10; endMonth = 12; break;
        default: startMonth = 1; endMonth = 12;
      }
    } else {
      startMonth = parseInt(selectedMonth);
      endMonth = parseInt(selectedMonth);
    }

    let provinces = [];
    for (const m of marketplaceKeys) {
      const data = marketplaceProvinceSummary[m];
      const firstMonthWithData = Object.keys(data).find(
        (month) => data[month] && Object.keys(data[month]).length > 0
      );
      if (firstMonthWithData) {
        provinces = Object.keys(data[firstMonthWithData]);
        break;
      }
    }

    if (provinceSearch) {
      const search = provinceSearch.toLowerCase();
      provinces = provinces.filter((p) => p.toLowerCase().includes(search));
    }

    const rows = [];

    for (let i = startMonth; i <= endMonth; i++) {
      const monthKey = i.toString().padStart(2, '0');
      const row = { name: monthNames[i - 1] };
      let monthTotal = 0;

      provinces.forEach((prov) => {
        // SALES MODE
        if (selectedValueType === 'sales') {
          const sum = marketplaceKeys.reduce((sum, m) => {
            const monthData = marketplaceProvinceSummary[m][monthKey] || {};
            return sum + ((monthData[prov] && monthData[prov].netProductSales) || 0);
          }, 0);

          row[prov] = sum;
          monthTotal += sum;
        }

        // TAX MODE
        if (selectedValueType === 'tax') {
          // COMBINE TAX
          if (combineTax) {
            const sumTax = marketplaceKeys.reduce((sum, m) => {
              const monthData = marketplaceProvinceSummary[m][monthKey] || {};
              const provData = monthData[prov] || {};

              const netTaxReceived = provData.netTaxReceived || 0;

              return sum + netTaxReceived;
            }, 0);


            row[prov] = sumTax;
            monthTotal += sumTax;
          }

          // SPLIT TAX
          if (splitTaxColumns) {
            const sumReceived = marketplaceKeys.reduce((sum, m) => {
              const monthData = marketplaceProvinceSummary[m][monthKey] || {};
              return sum + ((monthData[prov] && monthData[prov].taxReceived) || 0);
            }, 0);

            const sumWithheld = marketplaceKeys.reduce((sum, m) => {
              const monthData = marketplaceProvinceSummary[m][monthKey] || {};
              return sum + ((monthData[prov] && monthData[prov].orderTaxWithHeld) || 0);
            }, 0);

            row[`${prov}_received`] = sumReceived;
            row[`${prov}_withheld`] = sumWithheld;

            monthTotal += sumReceived + sumWithheld;
          }
        }
      });

      row.total = monthTotal;
      rows.push(row);
    }

    // TOTAL ROW
    const totalRow = { name: 'Total' };
    let grandTotal = 0;

    provinces.forEach((prov) => {
      if (selectedValueType === 'sales' || combineTax) {
        const provTotal = rows.reduce((sum, r) => sum + (r[prov] || 0), 0);
        totalRow[prov] = provTotal;
        grandTotal += provTotal;
      }

      if (splitTaxColumns) {
        const provTotalReceived = rows.reduce((sum, r) => sum + (r[`${prov}_received`] || 0), 0);
        const provTotalWithheld = rows.reduce((sum, r) => sum + (r[`${prov}_withheld`] || 0), 0);

        totalRow[`${prov}_received`] = provTotalReceived;
        totalRow[`${prov}_withheld`] = provTotalWithheld;

        grandTotal += provTotalReceived + provTotalWithheld;
      }
    });

    totalRow.total = grandTotal;
    rows.push(totalRow);

    return rows;
  };

  tableRow = (row) => {
    const isTotalRow = row.name === 'Total';

    return (
      <>
        <TableCell
          style={{
            width: '120px',
            fontWeight: isTotalRow ? 'bold' : 500,
            position: 'sticky',
            left: 0,
            background: '#fff',
            zIndex: 2,
          }}
        >
          {row.name}
        </TableCell>

        {Object.keys(row)
          .filter((k) => k !== 'name')
          .map((prov) => (
            <TableCell
              key={prov}
              style={{
                textAlign: 'right',
                fontWeight: isTotalRow ? 'bold' : 'normal',
              }}
            >
              {this.formatDollar(row[prov])}
            </TableCell>
          ))}
      </>
    );
  };

  formatDollar = (amount) => {
    if (!amount || isNaN(amount)) return '';
    const amountStr = parseFloat(amount).toFixed(2);
    return `$${amountStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  };


  listProvinceSummary = () => {
    const {
      selectedYear,
      selectedQuarters,
      selectedMonth = '',
      selectedCountry,
    } = this.state;

    const safeMonth = (selectedMonth || '').toString().trim();

    const data = {
      year: selectedYear || new Date().getFullYear(),
      quarter: selectedQuarters ? [selectedQuarters] : [1, 2, 3, 4],
      month: safeMonth,
      country: selectedCountry || 'Canada',
      marketplaces: this.state.selectedMarketplace || [],
      isRefresh: this.state.isRefresh,
    };

    this.props.listMarketplaceProvinceSummary(data);
  };

  setFetch = (bool)=>{
        this.setState({ isRefresh: bool }, () => {
          this.listProvinceSummary();
        });
    }

  handleYearChange = (event) => {
    this.setState({ selectedYear: event.target.value }, () => {
      this.onFiltersInputChange('year', event);
    });
  };

  handleMonthChange = (event) => {
    this.setState({ selectedMonth: event.target.value }, () => {
      this.onFiltersInputChange('month', event);
    });
  };

  handleCountryChange = (event) => {
    const selectedCountry = event.target.value;

    const marketplaceOptions =
      selectedCountry === 'Canada' ? CANADA_MARKETPLACES : USA_MARKETPLACES;
    this.setState(
      {
        selectedCountry,
        selectedMarketplace: marketplaceOptions,
      },
      () => {
        this.onFiltersInputChange('multiple', {
          country: selectedCountry,
          marketplaces: marketplaceOptions,
        });
        this.listProvinceSummary();
      }
    );
  };

  handleQuarterChange = (quarter) => {

    const quarterMapping = {
      'QTR 1': 1,
      'QTR 2': 2,
      'QTR 3': 3,
      'QTR 4': 4,
    };
    const quarterNumber = quarterMapping[quarter];
    const selectedQuarters =
      this.state.selectedQuarters === quarterNumber ? null : quarterNumber;
    this.setState({ selectedQuarters, selectedMonth : '', }, () => {
      this.onFiltersInputChange('quarters', this.state.selectedQuarters);
    });
  };

   getMonthsForQuarter = () => {
      const { selectedQuarters } = this.state;

      if (!selectedQuarters) {
        return [
          { name: 'January', value: '01' },
          { name: 'February', value: '02' },
          { name: 'March', value: '03' },
          { name: 'April', value: '04' },
          { name: 'May', value: '05' },
          { name: 'June', value: '06' },
          { name: 'July', value: '07' },
          { name: 'August', value: '08' },
          { name: 'September', value: '09' },
          { name: 'October', value: '10' },
          { name: 'November', value: '11' },
          { name: 'December', value: '12' },
        ]
      } else {
        switch (selectedQuarters) {
          case 1:
            return [  { name: 'January', value: '01' },
              { name: 'February', value: '02' },
              { name: 'March', value: '03' }]
          case 2:
            return [
              { name: 'April', value: '04' },
              { name: 'May', value: '05' },
              { name: 'June', value: '06' }]
          case 3:
            return [
              { name: 'July', value: '07' },
              { name: 'August', value: '08' },
              { name: 'September', value: '09'}]
          case 4:
            return [
              { name: 'October', value: '10' },
              { name: 'November', value: '11' },
              { name: 'December', value: '12' }]
          default:
            return [];
        }
      }
    }


  onFiltersInputChange = (name, event) => {
    let filtersMap = {
      ...(this.props.tableMarketplaceSetting?.marketplaceProvinceSummaryFilterSetting || {}),
    };

    if (name === 'quarters') {
      filtersMap[name] = event;
      filtersMap['month'] = "";
    } else if (name === 'multiple') {
      Object.assign(filtersMap, event);
    } else {
      filtersMap[name] = event.target.value;

      if (name === 'month' && event.target.value) {
          filtersMap['quarters'] = "";
      }
    }

    this.saveUpdatedFilters(filtersMap);
  };

  handleExport = () => {
    const originalState = { ...this.state };
    const csvSections = [];

    //  SALES TABLE
    this.setState(
      {
        selectedValueType: 'sales',
        combineTax: false,
        splitTaxColumns: false,
      },
      () => {
        const salesHeaders = this.buildCSVHeaders();
        const salesRows = this.buildCSVRows();

        csvSections.push(
          ...this.buildCSVSection(
            'Sales',
            salesHeaders,
            salesRows
          )
        );

      // TAX TABLE
        this.setState(
          {
            selectedValueType: 'tax',
            combineTax: !originalState.splitTaxColumns,
            splitTaxColumns: originalState.splitTaxColumns,
          },
          () => {
            const taxHeaders = this.buildCSVHeaders();
            const taxRows = this.buildCSVRows();

            const taxTitle = originalState.splitTaxColumns
              ? 'Taxes (Received / Withheld)'
              : 'Taxes (Net Tax Received)';

            csvSections.push(
              ...this.buildCSVSection(
                taxTitle,
                taxHeaders,
                taxRows
              )
            );


            // DOWNLOAD
            const csv = csvSections.join('\n');
            const filename = `Province-summary-${this.state.selectedYear}-${this.state.selectedCountry}.csv`;

            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.setState(originalState);
          }
        );
      }
    );
  };

  buildCSVSection = (title, headerRows, rows) => {
    const columnCount = headerRows[0].length;

    const leftPad = Math.floor((columnCount - 1) / 2);
    const titleRow = [
      ...Array(leftPad).fill(''),
      `${title.toUpperCase()}`,
      ...Array(columnCount - leftPad - 1).fill('')
    ].join(',');

    return [
      titleRow,
      ...headerRows.map(r => r.map(c => c.toUpperCase()).join(',')),
      ...rows,
      ''
    ];
  };

  buildCSVHeaders = () => {
    const tableHeaders = this.getTableHeaders();

    if (tableHeaders.length === 1) {
      return [[
        ...tableHeaders[0].map(c => c.props.children.toString())
      ]];
    }

    const main = tableHeaders[0];

    const mainRow = ['MONTH'];
    const subRow = [''];

    main.slice(1, -1).forEach(cell => {
      const province = cell.props.children.toString();
      mainRow.push(province, province);
      subRow.push(
        'RECEIVED',
        'WITHHELD'
      );
    });

    mainRow.push('TOTAL');
    subRow.push('');

    return [mainRow, subRow];
  };

  buildCSVRows = () => {
    const rows = this.getTableData();
    const { splitTaxColumns } = this.state;
    const headers = this.buildCSVHeaders();

    const mainHeader = headers[0];

    return rows.map(row => {
      const isTotal = row.name === 'Total';
      const values = [];

      values.push(isTotal ? 'TOTAL' : row.name);

      // Skip MONTH and TOTAL
      for (let i = 1; i < mainHeader.length - 1; i++) {
        const province = mainHeader[i];

        if (splitTaxColumns) {
          const received = Number(row[`${province}_received`] || 0);
          const withheld = Number(row[`${province}_withheld`] || 0);

          values.push(
            received === 0 ? '' : received.toFixed(2),
            withheld === 0 ? '' : withheld.toFixed(2)
          );
          i++; // skip duplicate province
        } else {
          const value = Number(row[province] || 0);
          values.push(value === 0 ? '' : value.toFixed(2));
        }
      }

      const totalValue = Number(row.total || 0);
      values.push(totalValue === 0 ? '' : totalValue.toFixed(2));

      return values.join(',');
    });
  };

  saveUpdatedFilters = (filters) => {
    this.props.saveTableSetting({
      userId: this.props.user.userId,
      tableSetting: null,
      changeFilters: false,
      changeMarketplaceProvinceSummaryFilters: true,
      marketplaceProvinceSummaryFilters: filters,
    });
  };

  getContextualMenuItems = () => [
    {
      title: 'Back',
      icon: <KeyboardBackspaceIcon />,
      onClick: () => this.props.setCurrentPage(MARKETPLACE_SUMMARY_PAGES.TABLE),
    },
     {
        title: 'Refresh',
        icon: <RefreshIcon />,
        onClick: () => {
          this.setFetch(true)
        }
      },
      {
          title: 'Download as CSV',
          icon: <FileDownloadIcon />,
          onClick: () => {
            this.handleExport()
          }
      },

    ...(this.props.loadingData
      ? [
          {
            icon: <HourglassEmptyTwoTone />,
            title: 'Loading data...',
            disabled: true,
          },
        ]
      : []),
  ];


  getMonthName = (value) => {
      const month = this.getMonthsForQuarter().find((m) => m.value === value);
      return month ? month.name : '';
  };

  render() {
       const {
      selectedYear,
      selectedMonth,
      selectedCountry,
      selectedQuarters,
      selectedMarketplace,
      openMarketplace,
    } = this.state;

    const country = ['Canada', 'United States'];
    const currentYear = new Date().getFullYear();
    const years = Array.from(
      { length: currentYear - 2022 },
      (_, i) => 2023 + i
    );

    const marketplaceOptions = this.state.selectedCountry === 'Canada' ? CANADA_MARKETPLACES : USA_MARKETPLACES

    const tableHeaders = this.getTableHeaders();
    const tableData = this.getTableData();

    return (
      <>
        <TopToolbar
          pageName={PROVINCE_MARKETPLACE_SUMMARY}
          menuItems={this.getContextualMenuItems()}
        />

        {/* Filters */}
        <Box
          sx={{
            marginTop: '32px',
            marginLeft: '32px',
            display: 'flex',
            flexWrap: 'wrap', // allows items to wrap to next line
            gap: 2, // spacing between items
            justifyContent: { xs: 'center', sm: 'flex-start' }, // center on small screens, left on larger
          }}
        >
          <TextField
            className="search-width-province"
            label="Search"
            name={'searchBar'}
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            value={this.state.provinceSearch}
            onChange={this.handleProvinceSearchChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    className={'clear-button'}
                    onClick={(e) => {
                      this.handleSearchChange('');
                    }}
                  >
                    <Clear />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Autocomplete
            className="full-width-province"
            options={years}
            getOptionLabel={(option) => option.toString()}
            value={selectedYear}
            onChange={(event, value) =>
              this.handleYearChange({ target: { value } })
            }
            renderInput={(params) => (
              <TextField {...params} label="Year" variant="outlined" />
            )}
          />

          <Autocomplete
              className="full-width-province"
              options={[
                { label: 'All', value: '' },
                ...this.getMonthsForQuarter().map((m) => ({
                  label: m.name,
                  value: m.value,
                })),
              ]}
              getOptionLabel={(option) => option.label}
              value={
                selectedMonth
                  ? { label: this.getMonthName(selectedMonth), value: selectedMonth }
                  : { label: 'All', value: '' }
              }
              onChange={(event, value) =>
                this.handleMonthChange({
                  target: { value: value ? value.value : '' },
                })
              }
              renderInput={(params) => (
                <TextField {...params} label="Month" variant="outlined" />
              )}
          />

          <Autocomplete
            className="full-width-province"
            options={country}
            value={selectedCountry}
            onChange={(event, value) =>
              this.handleCountryChange({ target: { value } })
            }
            renderInput={(params) => (
              <TextField {...params} label="Country" variant="outlined" />
            )}
          />

          <Autocomplete
            className="full-width-province-marketplaces"
            multiple
            open={openMarketplace}
            options={marketplaceOptions || []}
            value={selectedMarketplace || []}
            getOptionLabel={(option) => option}
            autoHighlight
            renderTags={(option) => {
              if (option.length > 1) {
                return (
                  <div
                    style={{
                      width: '100%',
                      display: 'inline-flex',
                      flexWrap: 'nowrap',
                      alignItems: 'center',
                    }}
                  >
                    <Chip
                      variant="outlined"
                      size="small"
                      style={{
                        borderColor: '#acd685',
                        margin: '1px 6px 1px 0',
                        fontSize: '12px',
                      }}
                      label={option[0]}
                    />
                    <Chip
                      variant="outlined"
                      size="small"
                      style={{
                        borderColor: '#acd685',
                        margin: '1px 6px 1px 0',
                        fontSize: '12px',
                      }}
                      label="..."
                    />
                  </div>
                );
              }
              return option.map((option) => (
                <Chip
                  variant="outlined"
                  size="small"
                  style={{
                    borderColor: '#acd685',
                    margin: '1px 6px 1px 0',
                    fontSize: '12px',
                  }}
                  label={option}
                />
              ));
            }}
            renderOption={(option, { selected }) => (
              <React.Fragment>
                <Checkbox
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </React.Fragment>
            )}
            onOpen={() => this.setState({ openMarketplace: true })}
            onClose={(event, reason) => {
              this.setState({ openMarketplace: reason !== 'blur' });
            }}
            onChange={this.handleMarketplaceChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Marketplace"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                name="marketplace"
              />
            )}
          />
        </Box>

        {/* Quarters */}
        <Box className="box1-purchase-summary">
          <div className="checkbox-purchase-container">
            <div className="chip-container">
              {['QTR 1', 'QTR 2', 'QTR 3', 'QTR 4'].map((quarter, index) => (
                <Chip
                  key={index}
                  label={quarter}
                  onClick={() => this.handleQuarterChange(quarter)}
                  className={`chip ${
                    selectedQuarters === index + 1 ? 'chip-selected' : ''
                  }`}
                />
              ))}
            </div>
          </div>

          <div style={{ marginTop: '22px', marginLeft: '8px' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.selectedValueType === 'sales'}
                  onChange={() =>
                    this.setState({
                      selectedValueType: 'sales',
                      combineTax: false,
                      splitTaxColumns: false,
                    })
                  }
                  icon={<CircleOutlinedIcon />}
                  checkedIcon={<CircleIcon />}
                />
              }
              label="Sales"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.selectedValueType === 'tax'}
                  onChange={() =>
                    this.setState({
                      selectedValueType: 'tax',
                      combineTax: true, // default select combineTax
                      splitTaxColumns: false, // make sure other is off
                    })
                  }
                  icon={<CircleOutlinedIcon />}
                  checkedIcon={<CircleIcon />}
                />
              }
              label="Taxes"
            />

            {this.state.selectedValueType === 'tax' && (
              <>

                <div
                  style={{
                    display: 'inline-block',
                    width: '1px',
                    height: '20px',
                    paddingTop: '20px',
                    backgroundColor: 'lightgray',
                    marginRight: '16px',
                  }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.combineTax}
                      onChange={(e) =>
                        this.setState({
                          combineTax: e.target.checked,
                          splitTaxColumns: false, // disable other
                        })
                      }
                    />
                  }
                  label="Net Tax Received"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.splitTaxColumns}
                      onChange={(e) =>
                        this.setState({
                          splitTaxColumns: e.target.checked,
                          combineTax: false, // disable other
                        })
                      }
                    />
                  }
                  label="Tax Received / Tax Withheld"
                />
              </>
            )}
          </div>
        </Box>


        <div
          style={{
            marginLeft: '32px',
            paddingTop: '16px',
            marginBottom: '16px',
          }}
        >
                  {' '}
          Last updated: {Utils.formatDateTime(
          this.props.provinceLastUpdatedAt
        )}{' '}
                </div>

        <div className="">
          <TableContainer>
            <Table size="medium" stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>{tableHeaders[0].map((cell) => cell)}</TableRow>

                {tableHeaders.length > 1 && (
                  <TableRow>{tableHeaders[1].map((cell) => cell)}</TableRow>
                )}
              </TableHead>

              <TableBody>
                {tableData.map((row, index) => (
                  <TableRow key={index}>{this.tableRow(row)}</TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </>
    );
  }
}

export default ProvinceSummaryTable;
